function getItem(key) {
  try {
    const serializedValue = localStorage.getItem(key);
    if (serializedValue === null) {
      return undefined;
    }
    return JSON.parse(serializedValue);
  } catch (error) {
    console.error('Error while retrieving data from localStorage:', error);
    return undefined;
  }
}

function setItem(key, value) {
  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    console.error('Error while storing data in localStorage:', error);
  }
}

function removeItem(key) {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error('Error while removing data from localStorage:', error);
  }
}

export default {
  getItem,
  setItem,
  removeItem,
}